import React from 'react'

// setting a default context of empty functions
const actionsButtonContext = React.createContext({
  onEditClicked: () => {},
  onDeleteClicked: () => {},
})

export default actionsButtonContext
